import React from 'react';
export const FirstFloorPage = () => (
    <div>
      <h1>This is the FirstFloor Page</h1>
    </div>
  );